var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('items-list',{attrs:{"businessId":_vm.businessId,"query":_vm.query,"filters":_vm.filters,"targetEntityId":_vm.targetEntityId,"category":"orderinprogress"},on:{"assign":_vm.assign,"assign-location":_vm.assignLocation,"history":_vm.history,"del":_vm.del}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }